import { render, staticRenderFns } from "./TradeOrderSummary.vue?vue&type=template&id=68cb5ebd&"
import script from "./TradeOrderSummary.vue?vue&type=script&lang=js&"
export * from "./TradeOrderSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports